<template lang="pug">
//- One row of a ticket picker, used by every dialog that offers a ticket to
//- book onto. Defined once so the three dialogs cannot drift into three
//- different ideas of what a ticket looks like in a list.
//-
//- Two lines, the same shape the support-tier and attachable-shop pickers use:
//- what it IS on top, what state it is in underneath. On one line the meta
//- landed at a different place on every row, because the subjects differ in
//- length - a ragged column nobody can scan.
//-
//- Separated by spacing and colour rather than middots: a row of separators
//- reads as one long string and hides exactly the facts worth scanning.
//- Styles live in globals.sass, because the dropdown is teleported to body.
.ticket-option
    span.ticket-option__name
        span.ticket-option__number {{ ticket.number }}
        span.ticket-option__subject {{ subject }}
    span.ticket-option__detail
        span.ticket-option__status(:class="`is-${ticket.status}`")
            i.ticket-option__dot
            | {{ statusLabel }}
        span.ticket-option__progress(v-if="progress > 0")
            span.ticket-option__bar
                i(:style="{ width: progress + '%' }")
            | {{ progress }} %
        span.ticket-option__time(v-if="seconds > 0") {{ time }}
</template>

<i18n>
{
    "en": {
    },
    "de": {
        "No subject": "Ohne Betreff"
    }
}
</i18n>

<script>
import _ from 'lodash';

import { supportTimeFormat, ticketSubject } from '@/filters';

export default {
    name: 'TicketOption',
    props: {
        ticket: {
            type: Object,
            required: true
        }
    },
    computed: {
        subject() {
            return ticketSubject(_.get(this.ticket, 'subject'), this.$t('No subject'));
        },
        statusLabel() {
            const status = _.get(this.ticket, 'status');

            return status ? this.$t(`ticket_status.${status}`) : '';
        },
        progress() {
            return parseInt(_.get(this.ticket, 'progress'), 10) || 0;
        },
        seconds() {
            return parseInt(_.get(this.ticket, 'support_time_seconds'), 10) || 0;
        },
        time() {
            return supportTimeFormat(this.seconds);
        }
    }
};
</script>
